import { JsonProperty, Any, JsonObject } from 'json2typescript';
import { ModelObject } from '@hermes/api-model-core';
import { Asset } from '@hermes/api-model-asset';
import { ProductVariants } from '@hermes/api-model-product';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * This class describe a single editorial content bloc
 * typed snackable_video
 */
let EditoResponse = class EditoResponse extends ModelObject {
    constructor() {
        super();
        this.nodeId = undefined;
        this.mediaType = undefined;
        this.contentTitle = undefined;
        this.contentBody = undefined;
        this.nodeUrl = undefined;
        this.imageDesktopUrl = undefined;
        this.imageDesktopAlt = undefined;
        this.imageMobileUrl = undefined;
        this.imageMobileAlt = undefined;
        this.videoUrl = undefined;
        this.videoAlt = undefined;
        this.videoLoopMuteAutoplay = undefined;
        this.alwaysShowControls = undefined;
        this.imageRetouched = undefined;
        this.token = undefined;
    }
};
__decorate([
    JsonProperty("nodeId", Number, true),
    __metadata("design:type", Number)
], EditoResponse.prototype, "nodeId", undefined);
__decorate([
    JsonProperty("mediaType", String, true),
    __metadata("design:type", String)
], EditoResponse.prototype, "mediaType", undefined);
__decorate([
    JsonProperty("contentTitle", String, true),
    __metadata("design:type", String)
], EditoResponse.prototype, "contentTitle", undefined);
__decorate([
    JsonProperty("contentBody", String, true),
    __metadata("design:type", String)
], EditoResponse.prototype, "contentBody", undefined);
__decorate([
    JsonProperty("nodeUrl", String, true),
    __metadata("design:type", String)
], EditoResponse.prototype, "nodeUrl", undefined);
__decorate([
    JsonProperty("imageDesktopUrl", String, true),
    __metadata("design:type", String)
], EditoResponse.prototype, "imageDesktopUrl", undefined);
__decorate([
    JsonProperty("imageDesktopAlt", String, true),
    __metadata("design:type", String)
], EditoResponse.prototype, "imageDesktopAlt", undefined);
__decorate([
    JsonProperty("imageMobileUrl", String, true),
    __metadata("design:type", String)
], EditoResponse.prototype, "imageMobileUrl", undefined);
__decorate([
    JsonProperty("imageMobileAlt", String, true),
    __metadata("design:type", String)
], EditoResponse.prototype, "imageMobileAlt", undefined);
__decorate([
    JsonProperty("videoUrl", String, true),
    __metadata("design:type", String)
], EditoResponse.prototype, "videoUrl", undefined);
__decorate([
    JsonProperty("videoAlt", String, true),
    __metadata("design:type", String)
], EditoResponse.prototype, "videoAlt", undefined);
__decorate([
    JsonProperty("videoLoopMuteAutoplay", Boolean, true),
    __metadata("design:type", Boolean)
], EditoResponse.prototype, "videoLoopMuteAutoplay", undefined);
__decorate([
    JsonProperty("alwaysShowControls", Boolean, true),
    __metadata("design:type", Boolean)
], EditoResponse.prototype, "alwaysShowControls", undefined);
__decorate([
    JsonProperty("imageRetouched", Boolean, true),
    __metadata("design:type", Boolean)
], EditoResponse.prototype, "imageRetouched", undefined);
__decorate([
    JsonProperty("token", Any, true),
    __metadata("design:type", Object)
], EditoResponse.prototype, "token", undefined);
EditoResponse = __decorate([
    JsonObject("EditoResponse"),
    __metadata("design:paramtypes", [])
], EditoResponse);

/**
 * This class describe a single bloc of contribution in CMS
 */
let Edito = class Edito extends ModelObject {
    constructor() {
        super();
        /** Node id in cms */
        this.nodeId = undefined;
        /** Title of edito */
        this.title = undefined;
        /** Type of edito */
        this.type = undefined; // TODO: enum à faire
        /** Edito content */
        this.content = undefined;
        /** Subtitle of edito ==> CMS cta_text */
        this.subTitle = undefined;
        /** Image of edito ==> CMS push categories content */
        this.image = undefined;
        /** Image of edito ==> CMS push categories content */
        this.path = undefined;
        this.childrens = [];
    }
};
__decorate([
    JsonProperty("nodeId", Number, true),
    __metadata("design:type", Number)
], Edito.prototype, "nodeId", undefined);
__decorate([
    JsonProperty("title", String, true),
    __metadata("design:type", String)
], Edito.prototype, "title", undefined);
__decorate([
    JsonProperty("type", String, true),
    __metadata("design:type", String)
], Edito.prototype, "type", undefined);
__decorate([
    JsonProperty("content", String, true),
    __metadata("design:type", String)
], Edito.prototype, "content", undefined);
__decorate([
    JsonProperty("subTitle", String, true),
    __metadata("design:type", String)
], Edito.prototype, "subTitle", undefined);
__decorate([
    JsonProperty("image", String, true),
    __metadata("design:type", String)
], Edito.prototype, "image", undefined);
__decorate([
    JsonProperty("path", String, true),
    __metadata("design:type", String)
], Edito.prototype, "path", undefined);
__decorate([
    JsonProperty("childrens", [Edito], true),
    __metadata("design:type", Array)
], Edito.prototype, "childrens", undefined);
Edito = __decorate([
    JsonObject("Edito"),
    __metadata("design:paramtypes", [])
], Edito);

var StoryBlockType;
(function (StoryBlockType) {
    StoryBlockType["BLOCK_FULL_HERO_MEDIA"] = "block_full_hero_media";
    StoryBlockType["BLOCK_HERO_MEDIA"] = "block_hero_media";
    StoryBlockType["BLOCK_STANDARD_MEDIA"] = "block_standard_media";
    StoryBlockType["BLOCK_TEXT"] = "block_text";
    StoryBlockType["BLOCK_DUO_MEDIA"] = "block_duo_media";
    StoryBlockType["BLOCK_MEDIA_TEXT"] = "block_media_text";
    StoryBlockType["BLOCK_MERCHANDISING"] = "block_merchandising";
})(StoryBlockType || (StoryBlockType = {}));

let StoryAnalyticsDeprecated = class StoryAnalyticsDeprecated extends ModelObject {
    constructor() {
        super(...arguments);
        this.editorialCategory = undefined;
        this.editorialTypology = undefined;
        this.editorialItem = undefined;
    }
};
__decorate([
    JsonProperty("editorial_category", String),
    __metadata("design:type", String)
], StoryAnalyticsDeprecated.prototype, "editorialCategory", undefined);
__decorate([
    JsonProperty("editorial_typology", String),
    __metadata("design:type", String)
], StoryAnalyticsDeprecated.prototype, "editorialTypology", undefined);
__decorate([
    JsonProperty("editorial_item", String),
    __metadata("design:type", String)
], StoryAnalyticsDeprecated.prototype, "editorialItem", undefined);
StoryAnalyticsDeprecated = __decorate([
    JsonObject("StoryAnalytics")
], StoryAnalyticsDeprecated);

let StoryMetaDeprecated = class StoryMetaDeprecated extends ModelObject {
    constructor() {
        super(...arguments);
        this.title = undefined;
        this.description = undefined;
        this.ogTitle = undefined;
        this.ogDescription = undefined;
        this.ogImage = undefined;
        this.ogUpdatedTime = undefined;
        this.twitterTitle = undefined;
        this.twitterDescription = undefined;
        this.twitterImage = undefined;
        this.itempropName = undefined;
        this.itempropDescription = undefined;
        this.itempropImage = undefined;
    }
};
__decorate([
    JsonProperty("title", String),
    __metadata("design:type", String)
], StoryMetaDeprecated.prototype, "title", undefined);
__decorate([
    JsonProperty("description", String, true),
    __metadata("design:type", String)
], StoryMetaDeprecated.prototype, "description", undefined);
__decorate([
    JsonProperty("og_title", String, true),
    __metadata("design:type", String)
], StoryMetaDeprecated.prototype, "ogTitle", undefined);
__decorate([
    JsonProperty("og_description", String, true),
    __metadata("design:type", String)
], StoryMetaDeprecated.prototype, "ogDescription", undefined);
__decorate([
    JsonProperty("og_image", String, true),
    __metadata("design:type", String)
], StoryMetaDeprecated.prototype, "ogImage", undefined);
__decorate([
    JsonProperty("og_updated_time", String, true),
    __metadata("design:type", String)
], StoryMetaDeprecated.prototype, "ogUpdatedTime", undefined);
__decorate([
    JsonProperty("twitter_title", String, true),
    __metadata("design:type", String)
], StoryMetaDeprecated.prototype, "twitterTitle", undefined);
__decorate([
    JsonProperty("twitter_description", String, true),
    __metadata("design:type", String)
], StoryMetaDeprecated.prototype, "twitterDescription", undefined);
__decorate([
    JsonProperty("twitter_image", String, true),
    __metadata("design:type", String)
], StoryMetaDeprecated.prototype, "twitterImage", undefined);
__decorate([
    JsonProperty("itemprop_name", String, true),
    __metadata("design:type", String)
], StoryMetaDeprecated.prototype, "itempropName", undefined);
__decorate([
    JsonProperty("itemprop_description", String, true),
    __metadata("design:type", String)
], StoryMetaDeprecated.prototype, "itempropDescription", undefined);
__decorate([
    JsonProperty("itemprop_image", String, true),
    __metadata("design:type", String)
], StoryMetaDeprecated.prototype, "itempropImage", undefined);
StoryMetaDeprecated = __decorate([
    JsonObject("StoryMeta")
], StoryMetaDeprecated);

let StoryContentDeprecated = class StoryContentDeprecated extends ModelObject {
    constructor() {
        super(...arguments);
        this.title = undefined;
        this.meta = undefined;
        this.analytics = undefined;
        this.paragraphList = [];
        this.immersiveContentColor = undefined;
    }
};
__decorate([
    JsonProperty("title", String),
    __metadata("design:type", String)
], StoryContentDeprecated.prototype, "title", undefined);
__decorate([
    JsonProperty("meta", StoryMetaDeprecated),
    __metadata("design:type", StoryMetaDeprecated)
], StoryContentDeprecated.prototype, "meta", undefined);
__decorate([
    JsonProperty("analytics", StoryAnalyticsDeprecated),
    __metadata("design:type", StoryAnalyticsDeprecated)
], StoryContentDeprecated.prototype, "analytics", undefined);
__decorate([
    JsonProperty("paragraph_list", []),
    __metadata("design:type", Array)
], StoryContentDeprecated.prototype, "paragraphList", undefined);
__decorate([
    JsonProperty("immersive_content_color", String, true),
    __metadata("design:type", String)
], StoryContentDeprecated.prototype, "immersiveContentColor", undefined);
StoryContentDeprecated = __decorate([
    JsonObject("StoryContent")
], StoryContentDeprecated);

var TemplateType;
(function (TemplateType) {
    TemplateType["story"] = "story";
    TemplateType["legal"] = "legal";
    TemplateType["accordion"] = "accordion";
})(TemplateType || (TemplateType = {}));
let StoryDeprecated = class StoryDeprecated extends ModelObject {
    constructor() {
        super(...arguments);
        this.id = undefined;
        this.template = undefined;
        this.path = undefined;
        this.altPaths = undefined;
        this.publishedTimestamp = undefined;
        this.storyContent = new StoryContentDeprecated();
    }
};
__decorate([
    JsonProperty("id", Number),
    __metadata("design:type", Number)
], StoryDeprecated.prototype, "id", undefined);
__decorate([
    JsonProperty("template", String),
    __metadata("design:type", String)
], StoryDeprecated.prototype, "template", undefined);
__decorate([
    JsonProperty("path", String),
    __metadata("design:type", String)
], StoryDeprecated.prototype, "path", undefined);
__decorate([
    JsonProperty("alt_paths", Any),
    __metadata("design:type", Object)
], StoryDeprecated.prototype, "altPaths", undefined);
__decorate([
    JsonProperty("published_timestamp", String),
    __metadata("design:type", String)
], StoryDeprecated.prototype, "publishedTimestamp", undefined);
__decorate([
    JsonProperty("story_content", StoryContentDeprecated),
    __metadata("design:type", StoryContentDeprecated)
], StoryDeprecated.prototype, "storyContent", undefined);
StoryDeprecated = __decorate([
    JsonObject("StoryDeprecated")
], StoryDeprecated);

var ParagraphTypeDeprecated;
(function (ParagraphTypeDeprecated) {
    ParagraphTypeDeprecated["blockDuoMedia"] = "block_duo_media";
    ParagraphTypeDeprecated["blockFullHeroMedia"] = "block_full_hero_media";
    ParagraphTypeDeprecated["blockHeroMedia"] = "block_hero_media";
    ParagraphTypeDeprecated["blockMediaText"] = "block_media_text";
    ParagraphTypeDeprecated["blockTextOnFullHeroMedia"] = "block_text_on_full_hero_media";
    ParagraphTypeDeprecated["blockStandardMedia"] = "block_standard_media";
    ParagraphTypeDeprecated["blockText"] = "block_text";
    ParagraphTypeDeprecated["blockYoutube"] = "block_youtube";
    ParagraphTypeDeprecated["galleryCarousel"] = "gallery_carousel";
    ParagraphTypeDeprecated["liveStream"] = "live_stream";
    ParagraphTypeDeprecated["pushCategoryPoster"] = "push_category_poster";
    ParagraphTypeDeprecated["pushEditorialSelection"] = "push_editorial_selection";
    ParagraphTypeDeprecated["pushMerchandising"] = "push_merchandising";
    ParagraphTypeDeprecated["bookingEvent"] = "block_event_booking";
    ParagraphTypeDeprecated["podcast"] = "push_podcast";
})(ParagraphTypeDeprecated || (ParagraphTypeDeprecated = {}));

/**
 * @dynamic
 */
let BlockTextDeprecated = class BlockTextDeprecated {
    constructor(source) {
        this.type = undefined;
        this.text = undefined;
        this.tokens = undefined;
        this.hasAnimation = undefined;
        this.whiteBackground = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("type", String),
    __metadata("design:type", String)
], BlockTextDeprecated.prototype, "type", undefined);
__decorate([
    JsonProperty("text", String),
    __metadata("design:type", String)
], BlockTextDeprecated.prototype, "text", undefined);
__decorate([
    JsonProperty("tokens", [Any], true),
    __metadata("design:type", Array)
], BlockTextDeprecated.prototype, "tokens", undefined);
__decorate([
    JsonProperty("has_animation", Boolean),
    __metadata("design:type", Boolean)
], BlockTextDeprecated.prototype, "hasAnimation", undefined);
__decorate([
    JsonProperty("white_background", Boolean),
    __metadata("design:type", Boolean)
], BlockTextDeprecated.prototype, "whiteBackground", undefined);
BlockTextDeprecated = __decorate([
    JsonObject("BlockTextDeprecated"),
    __metadata("design:paramtypes", [Object])
], BlockTextDeprecated);

/**
 * @dynamic
 */
let MediaDeprecated = class MediaDeprecated {
    constructor(source) {
        this.videoUrl = undefined;
        this.mobileVideoUrl = undefined;
        this.videoLoopMuteAutoplay = undefined;
        this.alwaysShowControls = undefined;
        this.mobileImage = undefined;
        this.desktopImage = undefined;
        this.imageAlt = undefined;
        this.imageRetouched = undefined;
        this.caption = undefined;
        this.credits = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("videoUrl", String),
    __metadata("design:type", String)
], MediaDeprecated.prototype, "videoUrl", undefined);
__decorate([
    JsonProperty("mobileVideoUrl", String),
    __metadata("design:type", String)
], MediaDeprecated.prototype, "mobileVideoUrl", undefined);
__decorate([
    JsonProperty("videoLoopMuteAutoplay", Boolean),
    __metadata("design:type", Boolean)
], MediaDeprecated.prototype, "videoLoopMuteAutoplay", undefined);
__decorate([
    JsonProperty("alwaysShowControls", Boolean),
    __metadata("design:type", Boolean)
], MediaDeprecated.prototype, "alwaysShowControls", undefined);
__decorate([
    JsonProperty("mobileImage", String),
    __metadata("design:type", String)
], MediaDeprecated.prototype, "mobileImage", undefined);
__decorate([
    JsonProperty("desktopImage", String),
    __metadata("design:type", String)
], MediaDeprecated.prototype, "desktopImage", undefined);
__decorate([
    JsonProperty("imageAlt", String, true),
    __metadata("design:type", String)
], MediaDeprecated.prototype, "imageAlt", undefined);
__decorate([
    JsonProperty("imageRetouched", Boolean),
    __metadata("design:type", Boolean)
], MediaDeprecated.prototype, "imageRetouched", undefined);
__decorate([
    JsonProperty("caption", String),
    __metadata("design:type", String)
], MediaDeprecated.prototype, "caption", undefined);
__decorate([
    JsonProperty("credits", String),
    __metadata("design:type", String)
], MediaDeprecated.prototype, "credits", undefined);
MediaDeprecated = __decorate([
    JsonObject("MediaDeprecated"),
    __metadata("design:paramtypes", [Object])
], MediaDeprecated);

/**
 * @dynamic
 */
let BlockMediaTextDeprecated = class BlockMediaTextDeprecated {
    constructor(source) {
        this.media = undefined;
        this.text = undefined;
        this.tokens = undefined;
        this.token = undefined;
        this.align = undefined;
        this.hasAnimation = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("type", String),
    __metadata("design:type", String)
], BlockMediaTextDeprecated.prototype, "type", undefined);
__decorate([
    JsonProperty("media", MediaDeprecated, true),
    __metadata("design:type", MediaDeprecated)
], BlockMediaTextDeprecated.prototype, "media", undefined);
__decorate([
    JsonProperty("text", String),
    __metadata("design:type", String)
], BlockMediaTextDeprecated.prototype, "text", undefined);
__decorate([
    JsonProperty("tokens", [Any], true),
    __metadata("design:type", Array)
], BlockMediaTextDeprecated.prototype, "tokens", undefined);
__decorate([
    JsonProperty("token", [Any], true),
    __metadata("design:type", Object)
], BlockMediaTextDeprecated.prototype, "token", undefined);
__decorate([
    JsonProperty("align", String, true),
    __metadata("design:type", String)
], BlockMediaTextDeprecated.prototype, "align", undefined);
__decorate([
    JsonProperty("has_animation", Boolean),
    __metadata("design:type", Boolean)
], BlockMediaTextDeprecated.prototype, "hasAnimation", undefined);
BlockMediaTextDeprecated = __decorate([
    JsonObject("BlockMediaTextDeprecated"),
    __metadata("design:paramtypes", [Object])
], BlockMediaTextDeprecated);

/**
 * @dynamic
 */
let BlockMediaDeprecated = class BlockMediaDeprecated {
    constructor(source) {
        this.media = undefined;
        this.hasAnimation = undefined;
        this.whiteBackground = undefined;
        this.hasDecorativeBackground = undefined;
        this.decorativeBgImgMobile = undefined;
        this.decorativeBgImgDesktop = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("type", String),
    __metadata("design:type", String)
], BlockMediaDeprecated.prototype, "type", undefined);
__decorate([
    JsonProperty("media", MediaDeprecated, true),
    __metadata("design:type", MediaDeprecated)
], BlockMediaDeprecated.prototype, "media", undefined);
__decorate([
    JsonProperty("has_animation", Boolean),
    __metadata("design:type", Boolean)
], BlockMediaDeprecated.prototype, "hasAnimation", undefined);
__decorate([
    JsonProperty("white_background", Boolean),
    __metadata("design:type", Boolean)
], BlockMediaDeprecated.prototype, "whiteBackground", undefined);
__decorate([
    JsonProperty("has_decorative_background", Boolean),
    __metadata("design:type", Boolean)
], BlockMediaDeprecated.prototype, "hasDecorativeBackground", undefined);
__decorate([
    JsonProperty("decorative_bg_img_mobile", String),
    __metadata("design:type", String)
], BlockMediaDeprecated.prototype, "decorativeBgImgMobile", undefined);
__decorate([
    JsonProperty("decorative_bg_img_desktop", String),
    __metadata("design:type", String)
], BlockMediaDeprecated.prototype, "decorativeBgImgDesktop", undefined);
BlockMediaDeprecated = __decorate([
    JsonObject("BlockMediaDeprecated"),
    __metadata("design:paramtypes", [Object])
], BlockMediaDeprecated);

/**
 * @dynamic
 */
let BlockDuoMediaDeprecated = class BlockDuoMediaDeprecated {
    constructor(source) {
        this.type = undefined;
        this.mediaLeft = undefined;
        this.mediaRight = undefined;
        this.hasAnimation = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("type", String),
    __metadata("design:type", String)
], BlockDuoMediaDeprecated.prototype, "type", undefined);
__decorate([
    JsonProperty("media_left", MediaDeprecated, true),
    __metadata("design:type", MediaDeprecated)
], BlockDuoMediaDeprecated.prototype, "mediaLeft", undefined);
__decorate([
    JsonProperty("media_right", MediaDeprecated, true),
    __metadata("design:type", MediaDeprecated)
], BlockDuoMediaDeprecated.prototype, "mediaRight", undefined);
__decorate([
    JsonProperty("has_animation", Boolean),
    __metadata("design:type", Boolean)
], BlockDuoMediaDeprecated.prototype, "hasAnimation", undefined);
BlockDuoMediaDeprecated = __decorate([
    JsonObject("BlockDuoMediaDeprecated"),
    __metadata("design:paramtypes", [Object])
], BlockDuoMediaDeprecated);

/**
 * @dynamic
 */
let BlockYoutubeDeprecated = class BlockYoutubeDeprecated {
    constructor(source) {
        this.type = undefined;
        this.whiteBackground = undefined;
        this.url = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("type", String),
    __metadata("design:type", String)
], BlockYoutubeDeprecated.prototype, "type", undefined);
__decorate([
    JsonProperty("white_background", Boolean, true),
    __metadata("design:type", Boolean)
], BlockYoutubeDeprecated.prototype, "whiteBackground", undefined);
__decorate([
    JsonProperty("url", String),
    __metadata("design:type", String)
], BlockYoutubeDeprecated.prototype, "url", undefined);
BlockYoutubeDeprecated = __decorate([
    JsonObject("BlockYoutubeDeprecated"),
    __metadata("design:paramtypes", [Object])
], BlockYoutubeDeprecated);

/**
 * @dynamic
 */
let MediaSlideDeprecated = class MediaSlideDeprecated {
    constructor(source) {
        this.title = undefined;
        this.media = undefined;
        this.token = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("title", String),
    __metadata("design:type", String)
], MediaSlideDeprecated.prototype, "title", undefined);
__decorate([
    JsonProperty("media", MediaDeprecated, true),
    __metadata("design:type", MediaDeprecated)
], MediaSlideDeprecated.prototype, "media", undefined);
__decorate([
    JsonProperty("token", Any, true),
    __metadata("design:type", Object)
], MediaSlideDeprecated.prototype, "token", undefined);
MediaSlideDeprecated = __decorate([
    JsonObject("MediaSlide"),
    __metadata("design:paramtypes", [Object])
], MediaSlideDeprecated);

/**
 * @dynamic
 */
let GalleryCarouselDeprecated = class GalleryCarouselDeprecated {
    constructor(source) {
        this.type = undefined;
        this.whiteBackground = undefined;
        this.mediaSlides = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("type", String),
    __metadata("design:type", String)
], GalleryCarouselDeprecated.prototype, "type", undefined);
__decorate([
    JsonProperty("white_background", Boolean, true),
    __metadata("design:type", Boolean)
], GalleryCarouselDeprecated.prototype, "whiteBackground", undefined);
__decorate([
    JsonProperty("media_slides", [MediaSlideDeprecated]),
    __metadata("design:type", Array)
], GalleryCarouselDeprecated.prototype, "mediaSlides", undefined);
GalleryCarouselDeprecated = __decorate([
    JsonObject("GalleryCarouselDeprecated"),
    __metadata("design:paramtypes", [Object])
], GalleryCarouselDeprecated);

/**
 * @dynamic
 */
let LiveStreamDeprecated = class LiveStreamDeprecated {
    constructor(source) {
        this.type = undefined;
        this.casterType = undefined;
        this.videoLayoutType = undefined;
        this.videoId = undefined;
        this.videoLoop = undefined;
        this.videoMute = undefined;
        this.videoAutoplay = undefined;
        this.videoControls = undefined;
        this.doNotTrack = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("type", String),
    __metadata("design:type", String)
], LiveStreamDeprecated.prototype, "type", undefined);
__decorate([
    JsonProperty("caster_type", String),
    __metadata("design:type", String)
], LiveStreamDeprecated.prototype, "casterType", undefined);
__decorate([
    JsonProperty("video_layout_type", String),
    __metadata("design:type", String)
], LiveStreamDeprecated.prototype, "videoLayoutType", undefined);
__decorate([
    JsonProperty("video_id", String),
    __metadata("design:type", String)
], LiveStreamDeprecated.prototype, "videoId", undefined);
__decorate([
    JsonProperty("video_loop", Boolean),
    __metadata("design:type", Boolean)
], LiveStreamDeprecated.prototype, "videoLoop", undefined);
__decorate([
    JsonProperty("video_mute", Boolean),
    __metadata("design:type", Boolean)
], LiveStreamDeprecated.prototype, "videoMute", undefined);
__decorate([
    JsonProperty("video_autoplay", Boolean),
    __metadata("design:type", Boolean)
], LiveStreamDeprecated.prototype, "videoAutoplay", undefined);
__decorate([
    JsonProperty("video_controls", Boolean),
    __metadata("design:type", Boolean)
], LiveStreamDeprecated.prototype, "videoControls", undefined);
__decorate([
    JsonProperty("dnt", Boolean),
    __metadata("design:type", Boolean)
], LiveStreamDeprecated.prototype, "doNotTrack", undefined);
LiveStreamDeprecated = __decorate([
    JsonObject("LiveStreamDeprecated"),
    __metadata("design:paramtypes", [Object])
], LiveStreamDeprecated);

/**
 * @dynamic
 */
let ImageDeprecated = class ImageDeprecated {
    constructor(source) {
        this.title = undefined;
        this.url = undefined;
        this.imageCta = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("title", String),
    __metadata("design:type", String)
], ImageDeprecated.prototype, "title", undefined);
__decorate([
    JsonProperty("url", String),
    __metadata("design:type", String)
], ImageDeprecated.prototype, "url", undefined);
__decorate([
    JsonProperty("image_cta", [Any], true),
    __metadata("design:type", Object)
], ImageDeprecated.prototype, "imageCta", undefined);
ImageDeprecated = __decorate([
    JsonObject("ImageDeprecated"),
    __metadata("design:paramtypes", [Object])
], ImageDeprecated);

/**
 * @dynamic
 */
let ImageLineDeprecated = class ImageLineDeprecated {
    constructor(source) {
        this.isThumbnail = undefined;
        this.images = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("is_thumbnail", Boolean),
    __metadata("design:type", Boolean)
], ImageLineDeprecated.prototype, "isThumbnail", undefined);
__decorate([
    JsonProperty("images", [ImageDeprecated]),
    __metadata("design:type", Array)
], ImageLineDeprecated.prototype, "images", undefined);
ImageLineDeprecated = __decorate([
    JsonObject("ImageLineDeprecated"),
    __metadata("design:paramtypes", [Object])
], ImageLineDeprecated);

/**
 * @dynamic
 */
let PushCategoryPosterDeprecated = class PushCategoryPosterDeprecated {
    constructor(source) {
        this.type = undefined;
        this.hasAnimation = undefined;
        this.imageLines = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("type", String),
    __metadata("design:type", String)
], PushCategoryPosterDeprecated.prototype, "type", undefined);
__decorate([
    JsonProperty("has_animation", Boolean),
    __metadata("design:type", Boolean)
], PushCategoryPosterDeprecated.prototype, "hasAnimation", undefined);
__decorate([
    JsonProperty("imagelines", [ImageLineDeprecated]),
    __metadata("design:type", Array)
], PushCategoryPosterDeprecated.prototype, "imageLines", undefined);
PushCategoryPosterDeprecated = __decorate([
    JsonObject("PushCategoryPosterDeprecated"),
    __metadata("design:paramtypes", [Object])
], PushCategoryPosterDeprecated);

/**
 * @dynamic
 */
let ProductStoryDeprecated = class ProductStoryDeprecated {
    constructor(source) {
        this.title = undefined;
        this.sku = undefined;
        this.price = undefined;
        this.category = undefined;
        this.variant = undefined;
        this.size = undefined;
        this.departementCode = undefined;
        this.familyCode = undefined;
        this.productCode = undefined;
        this.divisionCode = undefined;
        this.stock = undefined;
        this.personalization = undefined;
        this.productAvailability = undefined;
        this.url = undefined;
        this.avgColor = undefined;
        this.isColorless = false;
        /** Array of assets */
        this.assets = [];
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("title", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "title", undefined);
__decorate([
    JsonProperty("sku", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "sku", undefined);
__decorate([
    JsonProperty("price", Number, true),
    __metadata("design:type", Number)
], ProductStoryDeprecated.prototype, "price", undefined);
__decorate([
    JsonProperty("category", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "category", undefined);
__decorate([
    JsonProperty("variant", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "variant", undefined);
__decorate([
    JsonProperty("size", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "size", undefined);
__decorate([
    JsonProperty("departement_code", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "departementCode", undefined);
__decorate([
    JsonProperty("family_code", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "familyCode", undefined);
__decorate([
    JsonProperty("product_code", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "productCode", undefined);
__decorate([
    JsonProperty("division_code", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "divisionCode", undefined);
__decorate([
    JsonProperty("stock", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "stock", undefined);
__decorate([
    JsonProperty("personalization", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "personalization", undefined);
__decorate([
    JsonProperty("product_availability", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "productAvailability", undefined);
__decorate([
    JsonProperty("url", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "url", undefined);
__decorate([
    JsonProperty("avgColor", String, true),
    __metadata("design:type", String)
], ProductStoryDeprecated.prototype, "avgColor", undefined);
__decorate([
    JsonProperty("isColorless", Boolean, true),
    __metadata("design:type", Boolean)
], ProductStoryDeprecated.prototype, "isColorless", undefined);
__decorate([
    JsonProperty("assets", [Asset], true),
    __metadata("design:type", Array)
], ProductStoryDeprecated.prototype, "assets", undefined);
ProductStoryDeprecated = __decorate([
    JsonObject("ProductStoryDeprecated"),
    __metadata("design:paramtypes", [Object])
], ProductStoryDeprecated);

/**
 * @dynamic
 */
let PushMerchandisingDeprecated = class PushMerchandisingDeprecated {
    constructor(source) {
        this.type = undefined;
        this.hasAnimation = undefined;
        this.media = undefined;
        this.token = undefined;
        this.merchandisingMediaPosition = undefined;
        this.merchandisingProductSelector = undefined;
        this.merchandisingProducts = undefined;
        this.merchandisingPositionInStory = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("type", String),
    __metadata("design:type", String)
], PushMerchandisingDeprecated.prototype, "type", undefined);
__decorate([
    JsonProperty("has_animation", Boolean),
    __metadata("design:type", Boolean)
], PushMerchandisingDeprecated.prototype, "hasAnimation", undefined);
__decorate([
    JsonProperty("media", MediaDeprecated, true),
    __metadata("design:type", MediaDeprecated)
], PushMerchandisingDeprecated.prototype, "media", undefined);
__decorate([
    JsonProperty("token", Any),
    __metadata("design:type", Object)
], PushMerchandisingDeprecated.prototype, "token", undefined);
__decorate([
    JsonProperty("merchandising_media_position", String),
    __metadata("design:type", String)
], PushMerchandisingDeprecated.prototype, "merchandisingMediaPosition", undefined);
__decorate([
    JsonProperty("merchandising_product_selector", String, true),
    __metadata("design:type", String)
], PushMerchandisingDeprecated.prototype, "merchandisingProductSelector", undefined);
__decorate([
    JsonProperty("merchandising_products", [ProductStoryDeprecated], true),
    __metadata("design:type", Array)
], PushMerchandisingDeprecated.prototype, "merchandisingProducts", undefined);
__decorate([
    JsonProperty("merchandising_position_in_story", Number),
    __metadata("design:type", Number)
], PushMerchandisingDeprecated.prototype, "merchandisingPositionInStory", undefined);
PushMerchandisingDeprecated = __decorate([
    JsonObject("PushMerchandisingDeprecated"),
    __metadata("design:paramtypes", [Object])
], PushMerchandisingDeprecated);

/**
 * @dynamic
 */
let EditorialBlockDeprecated = class EditorialBlockDeprecated {
    constructor(source) {
        this.media = undefined;
        this.title = undefined;
        this.text = undefined;
        this.token = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("media", MediaDeprecated, true),
    __metadata("design:type", MediaDeprecated)
], EditorialBlockDeprecated.prototype, "media", undefined);
__decorate([
    JsonProperty("title", String, true),
    __metadata("design:type", String)
], EditorialBlockDeprecated.prototype, "title", undefined);
__decorate([
    JsonProperty("text", String, true),
    __metadata("design:type", String)
], EditorialBlockDeprecated.prototype, "text", undefined);
__decorate([
    JsonProperty("token", [Any], true),
    __metadata("design:type", Object)
], EditorialBlockDeprecated.prototype, "token", undefined);
EditorialBlockDeprecated = __decorate([
    JsonObject("EditorialBlockDeprecated"),
    __metadata("design:paramtypes", [Object])
], EditorialBlockDeprecated);

/**
 * @dynamic
 */
let PushEditorialSelectionDeprecated = class PushEditorialSelectionDeprecated {
    constructor(source) {
        this.type = undefined;
        this.hideCTA = undefined;
        this.editorialBlocks = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("type", String),
    __metadata("design:type", String)
], PushEditorialSelectionDeprecated.prototype, "type", undefined);
__decorate([
    JsonProperty("hide_cta", Boolean),
    __metadata("design:type", Boolean)
], PushEditorialSelectionDeprecated.prototype, "hideCTA", undefined);
__decorate([
    JsonProperty("editorialBlocks", [EditorialBlockDeprecated]),
    __metadata("design:type", Array)
], PushEditorialSelectionDeprecated.prototype, "editorialBlocks", undefined);
PushEditorialSelectionDeprecated = __decorate([
    JsonObject("PushEditorialSelectionDeprecated"),
    __metadata("design:paramtypes", [Object])
], PushEditorialSelectionDeprecated);

/**
 * @dynamic
 */
let BookingEventDeprecated = class BookingEventDeprecated {
    constructor(source) {
        this.type = undefined;
        this.link = undefined;
        this.parameters = undefined;
        this.title = undefined;
        this.lang = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("type", String),
    __metadata("design:type", String)
], BookingEventDeprecated.prototype, "type", undefined);
__decorate([
    JsonProperty("link", String),
    __metadata("design:type", String)
], BookingEventDeprecated.prototype, "link", undefined);
__decorate([
    JsonProperty("parameters", String, true),
    __metadata("design:type", String)
], BookingEventDeprecated.prototype, "parameters", undefined);
__decorate([
    JsonProperty("title", String),
    __metadata("design:type", String)
], BookingEventDeprecated.prototype, "title", undefined);
__decorate([
    JsonProperty("lang", String),
    __metadata("design:type", String)
], BookingEventDeprecated.prototype, "lang", undefined);
BookingEventDeprecated = __decorate([
    JsonObject("BookingEventDeprecated"),
    __metadata("design:paramtypes", [Object])
], BookingEventDeprecated);

/**
 * @dynamic
 */
let PodcastPlatformDeprecated = class PodcastPlatformDeprecated {
    constructor(source) {
        this.icon = undefined;
        this.title = undefined;
        this.url = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("icon", String, true),
    __metadata("design:type", String)
], PodcastPlatformDeprecated.prototype, "icon", undefined);
__decorate([
    JsonProperty("title", String),
    __metadata("design:type", String)
], PodcastPlatformDeprecated.prototype, "title", undefined);
__decorate([
    JsonProperty("url", String),
    __metadata("design:type", String)
], PodcastPlatformDeprecated.prototype, "url", undefined);
PodcastPlatformDeprecated = __decorate([
    JsonObject("PodcastPlatformDeprecated"),
    __metadata("design:paramtypes", [Object])
], PodcastPlatformDeprecated);

/**
 * @dynamic
 */
let PodcastDataDeprecated = class PodcastDataDeprecated {
    constructor(source) {
        this.title = undefined;
        this.episodeId = undefined;
        this.organisationId = undefined;
        this.audioUrl = undefined;
        this.imageUrl = undefined;
        this.description = undefined;
        this.duration = undefined;
        this.publishState = undefined;
        this.publishUrl = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("title", String),
    __metadata("design:type", String)
], PodcastDataDeprecated.prototype, "title", undefined);
__decorate([
    JsonProperty("episodeId", String),
    __metadata("design:type", String)
], PodcastDataDeprecated.prototype, "episodeId", undefined);
__decorate([
    JsonProperty("organisationId", String),
    __metadata("design:type", String)
], PodcastDataDeprecated.prototype, "organisationId", undefined);
__decorate([
    JsonProperty("audioUrl", String),
    __metadata("design:type", String)
], PodcastDataDeprecated.prototype, "audioUrl", undefined);
__decorate([
    JsonProperty("imageUrl", String, true),
    __metadata("design:type", String)
], PodcastDataDeprecated.prototype, "imageUrl", undefined);
__decorate([
    JsonProperty("description", String),
    __metadata("design:type", String)
], PodcastDataDeprecated.prototype, "description", undefined);
__decorate([
    JsonProperty("duration", Number),
    __metadata("design:type", Number)
], PodcastDataDeprecated.prototype, "duration", undefined);
__decorate([
    JsonProperty("publishState", String, true),
    __metadata("design:type", String)
], PodcastDataDeprecated.prototype, "publishState", undefined);
__decorate([
    JsonProperty("publishUrl", String, true),
    __metadata("design:type", String)
], PodcastDataDeprecated.prototype, "publishUrl", undefined);
PodcastDataDeprecated = __decorate([
    JsonObject("PodcastDataDeprecated"),
    __metadata("design:paramtypes", [Object])
], PodcastDataDeprecated);

/**
 * @dynamic
 */
let PodcastDeprecated = class PodcastDeprecated {
    constructor(source) {
        this.type = undefined;
        this.organizationId = undefined;
        this.episodeId = undefined;
        this.platforms = undefined;
        this.omnyData = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("type", String),
    __metadata("design:type", String)
], PodcastDeprecated.prototype, "type", undefined);
__decorate([
    JsonProperty("organization_id", String),
    __metadata("design:type", String)
], PodcastDeprecated.prototype, "organizationId", undefined);
__decorate([
    JsonProperty("episode_id", String),
    __metadata("design:type", String)
], PodcastDeprecated.prototype, "episodeId", undefined);
__decorate([
    JsonProperty("platforms", [PodcastPlatformDeprecated], true),
    __metadata("design:type", Array)
], PodcastDeprecated.prototype, "platforms", undefined);
__decorate([
    JsonProperty("omnyData", PodcastDataDeprecated),
    __metadata("design:type", PodcastDataDeprecated)
], PodcastDeprecated.prototype, "omnyData", undefined);
PodcastDeprecated = __decorate([
    JsonObject("PodcastDeprecated"),
    __metadata("design:paramtypes", [Object])
], PodcastDeprecated);

const TOKEN_TYPE = {
    ctaCategory: "ctaCategory",
    ctaStory: "ctaStory",
    ctaVto: "ctaVto",
    ctaMissing: "ctaMissing",
};

/**
 * These attributes are only used for Fragrance Finder Question Model need Answer object
 */
let FragranceFinderAnswer = class FragranceFinderAnswer {
    constructor(source) {
        this.id = undefined;
        this.translationKey = undefined;
        this.imageDesktopUrl = undefined;
        this.imageMobileUrl = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("id", String),
    __metadata("design:type", String)
], FragranceFinderAnswer.prototype, "id", undefined);
__decorate([
    JsonProperty("translation_key", String),
    __metadata("design:type", String)
], FragranceFinderAnswer.prototype, "translationKey", undefined);
__decorate([
    JsonProperty("image_desktop_url", String),
    __metadata("design:type", String)
], FragranceFinderAnswer.prototype, "imageDesktopUrl", undefined);
__decorate([
    JsonProperty("image_mobile_url", String),
    __metadata("design:type", String)
], FragranceFinderAnswer.prototype, "imageMobileUrl", undefined);
FragranceFinderAnswer = __decorate([
    JsonObject("FragranceFinderAnswer"),
    __metadata("design:paramtypes", [FragranceFinderAnswer])
], FragranceFinderAnswer);

/**
 * These attributes are only used for matrix candidate products in fragrance finder
 */
let ProductMatrix = class ProductMatrix {
    constructor(source) {
        this.sku = undefined;
        this.answerIds = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("sku", String),
    __metadata("design:type", String)
], ProductMatrix.prototype, "sku", undefined);
__decorate([
    JsonProperty("answer_ids", [String]),
    __metadata("design:type", Array)
], ProductMatrix.prototype, "answerIds", undefined);
ProductMatrix = __decorate([
    JsonObject("productMatrix"),
    __metadata("design:paramtypes", [ProductMatrix])
], ProductMatrix);

/**
 * These attributes are only used for Fragrance finder questions
 */
let FragranceFinderQuestion = class FragranceFinderQuestion {
    constructor(source) {
        this.id = undefined;
        this.text = undefined;
        this.answers = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("id", Number),
    __metadata("design:type", Number)
], FragranceFinderQuestion.prototype, "id", undefined);
__decorate([
    JsonProperty("text", String),
    __metadata("design:type", String)
], FragranceFinderQuestion.prototype, "text", undefined);
__decorate([
    JsonProperty("answers", [FragranceFinderAnswer]),
    __metadata("design:type", Array)
], FragranceFinderQuestion.prototype, "answers", undefined);
FragranceFinderQuestion = __decorate([
    JsonObject("FragranceFinderQuestion"),
    __metadata("design:paramtypes", [FragranceFinderQuestion])
], FragranceFinderQuestion);

/**
 * This class describes a fragrance finder csv file
 */
let FragranceFinder = class FragranceFinder {
    constructor(source) {
        this.landingPageImageDesktopUrl = undefined;
        this.landingPageImageMobileUrl = undefined;
        this.questions = undefined;
        this.productsMatrix = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("landing_page_image_desktop_url", String),
    __metadata("design:type", String)
], FragranceFinder.prototype, "landingPageImageDesktopUrl", undefined);
__decorate([
    JsonProperty("landing_page_image_mobile_url", String),
    __metadata("design:type", String)
], FragranceFinder.prototype, "landingPageImageMobileUrl", undefined);
__decorate([
    JsonProperty("questions", [FragranceFinderQuestion]),
    __metadata("design:type", Array)
], FragranceFinder.prototype, "questions", undefined);
__decorate([
    JsonProperty("products_matrix", [ProductMatrix]),
    __metadata("design:type", Array)
], FragranceFinder.prototype, "productsMatrix", undefined);
FragranceFinder = __decorate([
    JsonObject("FragranceFinder"),
    __metadata("design:paramtypes", [FragranceFinder])
], FragranceFinder);

/**
 * @dynamic
 */
let FragranceFinderElectedProduct = class FragranceFinderElectedProduct {
    constructor(source) {
        this.sku = undefined;
        this.slug = undefined;
        this.price = undefined;
        this.currency = undefined;
        this.title = undefined;
        this.variationType = undefined;
        this.variants = undefined;
        this.volume = undefined;
        this.unit = undefined;
        this.url = undefined;
        this.olfactoryNote = undefined;
        this.olfactoryNoteLabel = undefined;
        this.assets = [];
        this.templateType = undefined;
        this.departmentCode = undefined;
        this.familyCode = undefined;
        this.productCode = undefined;
        this.stock = undefined;
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("sku", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "sku", undefined);
__decorate([
    JsonProperty("slug", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "slug", undefined);
__decorate([
    JsonProperty("price", Number),
    __metadata("design:type", Number)
], FragranceFinderElectedProduct.prototype, "price", undefined);
__decorate([
    JsonProperty("currency", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "currency", undefined);
__decorate([
    JsonProperty("title", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "title", undefined);
__decorate([
    JsonProperty("variationType", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "variationType", undefined);
__decorate([
    JsonProperty("variants", ProductVariants),
    __metadata("design:type", Object)
], FragranceFinderElectedProduct.prototype, "variants", undefined);
__decorate([
    JsonProperty("volume", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "volume", undefined);
__decorate([
    JsonProperty("unit", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "unit", undefined);
__decorate([
    JsonProperty("url", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "url", undefined);
__decorate([
    JsonProperty("olfactory_note", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "olfactoryNote", undefined);
__decorate([
    JsonProperty("olfactory_note_label", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "olfactoryNoteLabel", undefined);
__decorate([
    JsonProperty("assets", [Asset]),
    __metadata("design:type", Array)
], FragranceFinderElectedProduct.prototype, "assets", undefined);
__decorate([
    JsonProperty("templateType", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "templateType", undefined);
__decorate([
    JsonProperty("departmentCode", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "departmentCode", undefined);
__decorate([
    JsonProperty("familyCode", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "familyCode", undefined);
__decorate([
    JsonProperty("productCode", String),
    __metadata("design:type", String)
], FragranceFinderElectedProduct.prototype, "productCode", undefined);
__decorate([
    JsonProperty("stock", Boolean),
    __metadata("design:type", Boolean)
], FragranceFinderElectedProduct.prototype, "stock", undefined);
FragranceFinderElectedProduct = __decorate([
    JsonObject("FragranceFinderElectedProduct"),
    __metadata("design:paramtypes", [Object])
], FragranceFinderElectedProduct);

export { BlockDuoMediaDeprecated, BlockMediaDeprecated, BlockMediaTextDeprecated, BlockTextDeprecated, BlockYoutubeDeprecated, BookingEventDeprecated, Edito, EditoResponse, EditorialBlockDeprecated, FragranceFinder, FragranceFinderAnswer, FragranceFinderElectedProduct, FragranceFinderQuestion, GalleryCarouselDeprecated, ImageDeprecated, ImageLineDeprecated, LiveStreamDeprecated, MediaDeprecated, MediaSlideDeprecated, ParagraphTypeDeprecated, PodcastDataDeprecated, PodcastDeprecated, PodcastPlatformDeprecated, ProductMatrix, ProductStoryDeprecated, PushCategoryPosterDeprecated, PushEditorialSelectionDeprecated, PushMerchandisingDeprecated, StoryAnalyticsDeprecated, StoryBlockType, StoryContentDeprecated, StoryDeprecated, StoryMetaDeprecated, TOKEN_TYPE, TemplateType };
